import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import moment from 'moment';

import {
  Grid,
  Typography,
  InfiniteScroller,
  Spinner,
} from '@upperhand/playmaker';
import Clock from 'components/Clock';
import CompanyLogo from 'components/CompanyLogo';
import FullPageError from 'components/errors/FullPageError';
import MainHeader from 'components/MainHeader';

import { sessionActions } from 'store/actions/dataSources';
import { getRole } from 'utils/auth';

import SessionItem from './components/SessionItem';

import './SessionList.css';

const START_TIME = moment()
  .startOf('day')
  .toISOString();

const END_TIME = moment()
  .endOf('day')
  .toISOString();

const SessionList = props => {
  const {
    activeSessionIds,
    address,
    customer: { name: customerName },
    error,
    hasMore,
    isLoading,
    page,
  } = props;

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      sessionActions.list({
        startTime: START_TIME,
        endTime: END_TIME,
      })
    );
  }, [dispatch]);

  const getCustomerLocation = () => {
    const customerCity = address?.city;
    const customerState = address?.state;

    return customerCity && customerState && `${customerCity}, ${customerState}`;
  };

  const handleScroll = () => {
    dispatch(
      sessionActions.list({
        page: page + 1,
        startTime: START_TIME,
        endTime: END_TIME,
      })
    );
  };

  const customerLocation = getCustomerLocation();
  const dateHeader = moment().format('dddd, MMMM D');
  const noSessionsText = 'No sessions today';

  if (error) {
    return <FullPageError />;
  }

  return (
    <>
      <MainHeader showBackLink={false} />
      <div className="MainContent">
        <Grid container spacing={5} direction="column">
          <Grid item>
            <header>
              <Grid
                container
                justify="space-between"
                wrap="nowrap"
                alignItems="center"
              >
                <Grid item container alignItems="center" spacing={2}>
                  <Grid item>
                    <h2 className="kiosk-header-text">
                      <Clock />
                    </h2>
                  </Grid>
                  <Grid item>
                    <Typography variant="h3">{customerName}</Typography>
                    {customerLocation && (
                      <Typography variant="body1">
                        {customerLocation}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
                <Grid item>
                  <CompanyLogo />
                </Grid>
              </Grid>
            </header>
          </Grid>
          <Grid item>
            <Typography variant="h3" component="h3">
              {dateHeader}
            </Typography>
          </Grid>
          <Grid item>
            {!isLoading && !activeSessionIds.length ? (
              noSessionsText
            ) : (
              <InfiniteScroller
                hasMore={hasMore}
                onScroll={handleScroll}
                isLoading={isLoading}
                loader={
                  <Grid container justify="center" spacing={3}>
                    <Grid item>
                      <Spinner />
                    </Grid>
                  </Grid>
                }
                showLoader
              >
                {activeSessionIds.map(id => (
                  <SessionItem key={id} sessionId={id} />
                ))}
              </InfiniteScroller>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

const mapStateToProps = ({ app: { error }, entities, ui: { sessions } }) => {
  const customer = entities.customers.data[getRole()?.customerId] || {};
  const { addressId } = customer;
  const address = addressId && entities.addresses.data[addressId];

  return {
    activeSessionIds: sessions.activeSessionIds,
    address,
    customer,
    error,
    isLoading: sessions.isLoading,
    page: sessions.page,
    hasMore: sessions.hasMore,
  };
};

export default connect(mapStateToProps)(SessionList);
